/* eslint-disable no-unused-vars */
/* eslint-disable no-return-assign */

import {
  notifyError,
  notifySuccess,
  notifyInfo,
  CLICK_TYPE,
} from '../util/graphUtil';
import React from 'react';
import { connect } from 'dva';
import { history } from 'umi';
import { message } from 'antd';
import { graphComputed } from '../config/graphComputedConfig';
import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
import TablePage from '../components/table_page/TablePage';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/polar';
import 'echarts/lib/chart/graph';
import 'echarts/lib/component/title';
import './graphMap.less';
import styles from './graphMap.less?modules';
import * as echarts from 'echarts';
import debounce from 'lodash/debounce';

class GraphMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      diagramId: '',
      // echartsWidth: 1600,
      echartsHeight: 500,
      startNode: {},
      endNode: {},
      nodes: {
        nodeResponseList: [],
        nodePointerResponseList: [],
      },
      originNodes: {
        nodeResponseList: [],
        nodePointerResponseList: [],
      },
      aliveNodes: [],
      alivePointers: [],
      lineStart: null,
      nodeInfo: {},
      visible: false,
      left: 0,
      top: 0,
      currentSelectedElement: null,
      currentClickType: CLICK_TYPE.OTHERS,
      isShowAddNodeConfig: false,
      isShowDeleteNodeConfig: false,
    };
    this.setAlive = debounce(this.setAlive, 400);
  }

  componentDidMount() {
    this.loadData();
    this.fetchData();
    window.addEventListener('click', this.closeMenu);
  }

  refresh = () => {
    const options = graphComputed(
      this.state.nodes.nodeResponseList,
      this.state.nodes.nodePointerResponseList,
      this.state.startNode,
      this.state.endNode,
    );
    const { x, y } = options;
    this.setState({
      echartsWidth: this.state.echartsWidth > x ? this.state.echartsWidth : x,
      echartsHeight:
        this.state.echartsHeight > y ? this.state.echartsHeight : y,
    });
    this.setCharts(options);
  };

  loadData = () => {
    this.props.dispatch({
      type: 'dgmp/getDecisionGraphMap',
      payload: {
        values: history.location.query.id,
      },
      callback: (data) => {
        if (data) {
          let startNodeUnUse = {
            nodeId: data.startNode.nodeId,
            nodeName: data.startNode.nodeName,
            nodeBlockId: data.startNode.nodeBlockId,
            nodeBlockType: data.startNode.nodeBlockType,
          };
          let endNodeUnUse = {
            nodeId: data.endNode.nodeId,
            nodeName: data.endNode.nodeName,
            nodeBlockId: data.endNode.nodeBlockId,
            nodeBlockType: data.endNode.nodeBlockType,
          };
          let nodeResponseList = data.nodeResponseList.sort(
            (p, n) => p.nodeId - n.nodeId,
          );
          nodeResponseList.forEach((e) => (e.isNew = false));
          let nodePointerResponseList = data.nodePointerResponseList.sort(
            (p, n) => p.id - n.id,
          );
          this.setState(
            {
              startNode: startNodeUnUse,
              endNode: endNodeUnUse,
              nodes: {
                nodeResponseList: nodeResponseList,
                nodePointerResponseList: nodePointerResponseList,
              },
              originNodes: {
                nodeResponseList: nodeResponseList,
                nodePointerResponseList: nodePointerResponseList,
              },
            },
            () => {
              this.refresh();
            },
          );
        } else {
          message.error('查询失败！');
        }
      },
    });
  };

  highLightingNode = (e) => {
    const options = graphComputed(
      this.state.nodes.nodeResponseList,
      this.state.nodes.nodePointerResponseList,
      this.state.startNode,
      this.state.endNode,
    );
    options.series[0].data[
      options.series[0].data.findIndex((s) => s.name === e.name)
    ].symbolSize = '60';
    options.series[0].data[
      options.series[0].data.findIndex((s) => s.name === e.name)
    ].itemStyle = { color: 'red' };
    this.setCharts(options);
  };

  chartssize = (container, charts) => {
    // 获取整体box容器宽高
    let wi = this.state.echartsWidth;
    let hi = this.state.echartsHeight;
    // chart宽度 = 容器宽度 - 2个padding
    charts.style.width = parseFloat(wi) + 'px';
    // chart高度 = 容器高度 - 头部高度
    charts.style.height = parseFloat(hi) + 'px';
  };

  setCharts = (options) => {
    let that = this;
    let { lineStart, startNode, nodes, endNode } = that.state;
    let chartBox = document.getElementById('chart1');
    let chart = document.getElementById('test-dome');
    that.chartssize(chartBox, chart);
    let myChart = echarts?.init(chart);
    // 清除点击事件
    myChart.off('click');
    myChart.off('contextmenu');
    myChart.on('click', function (e) {
      that.setState({
        currentSelectedElement: e,
        currentSelectedElementShadow: e,
      });
      const isClickElementIsPointer = e.dataType === 'edge';
      if (isClickElementIsPointer) {
        return;
      }
      if (lineStart) {
        if (lineStart.name === e.name) {
          notifyInfo(`已取消节点 [${lineStart.name}] 的连线`);
          that.setState(
            {
              lineStart: null,
            },
            () => {
              that.refresh();
            },
          );
          return;
        }
        if (e.value[0].nodeId === startNode.nodeId) {
          notifyError('不允许连线终点为起始节点');
          return;
        }
        const pointer = {
          previousNodeId: lineStart.value[0].nodeId,
          nextNodeId: e.value[0].nodeId,
        };
        // 禁止反向连接
        const isPointerReverse = nodes.nodePointerResponseList.findIndex(
          (item) =>
            item.previousNodeId === pointer.nextNodeId &&
            item.nextNodeId === pointer.previousNodeId,
        );
        if (isPointerReverse !== -1) {
          notifyError(`连线 [${lineStart.name}] - [${e.name}] 不能反向连线`);
          return;
        }
        const isPointerExists = nodes.nodePointerResponseList.findIndex(
          (item) =>
            item.previousNodeId === pointer.previousNodeId &&
            item.nextNodeId === pointer.nextNodeId,
        );
        if (isPointerExists !== -1) {
          notifyError(`连线 [${lineStart.name}] - [${e.name}] 已存在`);
          return;
        }
        nodes.nodePointerResponseList.push(pointer);
        notifySuccess(`已完成连线 [${lineStart.name}] - [${e.name}]`);
        that.setState(
          {
            lineStart: null,
          },
          () => {
            that.refresh();
          },
        );
      } else if (e.value[0].nodeId !== endNode.nodeId) {
        notifyInfo(`当前连线起始节点[${e.name}]`);
        that.setState(
          {
            lineStart: e,
          },
          () => {
            that.highLightingNode(e);
          },
        );
      }
    });
    myChart.on('contextmenu', function (e) {
      document.oncontextmenu = function () {
        return false;
      };
      if (!e) {
        return;
      }
      if (e.dataType === 'node') {
        that.setState({
          currentClickType: CLICK_TYPE.NODE,
        });
      } else if (e.dataType === 'edge') {
        that.setState({
          currentClickType: CLICK_TYPE.POINTER,
        });
      }
      that.setState({
        currentSelectedElement: e,
        currentSelectedElementShadow: e,
        visible: true,
        left: e.event.event.zrX + 20,
        top: e.event.event.y,
      });
    });
    myChart.setOption(options, true);
  };

  // 右键点击后选择menu
  handleContextMenu = (selectedElement, clickItem) => {
    if (selectedElement.dataType === 'node') {
      this.handleNodeContextMenu(selectedElement, clickItem);
    } else {
      this.handlePointerContextMenu(selectedElement, clickItem);
    }
  };
  // 圆点击右键
  handleNodeContextMenu = (selectedElement, clickItem) => {
    const clickItemFuncMap = {
      ADD_CHILD_NODE: () => {
        this.setState({
          isShowAddNodeConfig: true,
        });
      },
      INPUT_ITEM_CONFIG: (e) => {
        if (e.value[0].isNew) {
          notifyError('当前节点为未保存状态，请先保存后再操作！');
          return;
        }
        history.push({
          pathname: '/bre/dgm/dgm/dgmp/dgic',
          query: {
            title: encodeURIComponent(`${e.name}入参配置`),
            nodeId: encodeURIComponent(e.value[0].nodeId),
            nodeName: encodeURIComponent(e.name),
          },
        });
      },
      DELETE_NODE: (e) => {
        if (
          e.value[0].nodeId === this.state.startNode.nodeId ||
          e.value[0].nodeId === this.state.endNode.nodeId
        ) {
          notifyInfo('起始和终止节点不可删除');
          return;
        }
        this.setState({
          isShowDeleteNodeConfig: true,
          nodeInfo: e,
        });
      },
      NODE_CONFIG: (e) => {
        const node = e.value[0];
        if (e.value[0].isNew) {
          notifyError('当前节点为未保存状态，请先保存后再操作！');
          return;
        }
        if (node.nodeBlockType === 'MODEL') {
          history.push({
            pathname: '/bre/mm/md',
            query: {
              title: encodeURIComponent(node.nodeName),
              modelID: encodeURIComponent(node.nodeBlockId),
            },
          });
        } else {
          history.push({
            pathname: '/bre/rm/rule',
            query: {
              title: encodeURIComponent(node.nodeName),
              id: encodeURIComponent(node.nodeBlockId),
            },
          });
        }
      },
    };
    clickItemFuncMap[clickItem](selectedElement);
  };

  // 线点击右键
  handlePointerContextMenu = (selectedElement, clickItem) => {
    const clickItemFuncMap = {
      CONDITION_CONFIG: ({ data }) => {
        const { id, previousNodeId } = data.origin;
        let previousNode = this.state.nodes.nodeResponseList.find(
          (e) => e.nodeId === previousNodeId,
        );
        if (!previousNode && previousNodeId === this.state.startNode.nodeId) {
          previousNode = this.state.startNode;
        }
        if (!previousNode && previousNodeId === this.state.endNode.nodeId) {
          previousNode = this.state.endNode;
        }
        if (id) {
          this.props.dispatch({
            type: 'dgmp/queryCombineRelation',
            payload: {
              values: {
                hostId: id,
                hostType: 'NODE_POINTER',
              },
            },
            callback: (res) => {
              const lineName = `${data.source} - ${data.target}`;
              if (res && res.conditionMode === 'MULTIPLE') {
                const currentTitle =
                  decodeURIComponent(lineName) + '-(多条件配置)';
                history.push({
                  pathname: '/rulesManagement/rulesConfigMultipleMode',
                  query: {
                    title: encodeURIComponent(currentTitle),
                    ruleName: encodeURIComponent(lineName),
                    outputResult: encodeURIComponent(lineName),
                    hostId: encodeURIComponent(id),
                    hostType: encodeURIComponent('NODE_POINTER'),
                    previousNodeBlock: encodeURIComponent(
                      previousNode.nodeBlockId,
                    ),
                    previousNodeBlockType: encodeURIComponent(
                      previousNode.nodeBlockType,
                    ),
                  },
                });
              } else {
                const currentTitle =
                  decodeURIComponent(lineName) + '-(单条件配置)';
                history.push({
                  pathname: '/bre/rm/rule/cfg',
                  query: {
                    // title: encodeURIComponent(currentTitle),
                    // ruleName: encodeURIComponent(lineName),
                    // outputResult: encodeURIComponent(lineName),
                    // hostId: encodeURIComponent(id),
                    // hostType: encodeURIComponent('NODE_POINTER'),
                    // previousNodeBlock: encodeURIComponent(
                    //   previousNode.nodeBlockId,
                    // ),
                    // previousNodeBlockType: encodeURIComponent(
                    //   previousNode.nodeBlockType,
                    // ),
                    title: encodeURIComponent(currentTitle),
                    name: lineName,
                    outputResult: encodeURIComponent(lineName),
                    id: encodeURIComponent(id),
                    hostType: encodeURIComponent('NODE_POINTER'),
                    previousNodeBlock: encodeURIComponent(
                      previousNode.nodeBlockId,
                    ),
                    previousNodeBlockType: encodeURIComponent(
                      previousNode.nodeBlockType,
                    ),
                  },
                });
              }
            },
          });
        } else {
          notifyError('该节点指针暂未保存，请先保存！');
        }
      },
      INSERT_CHILD_NODE: () => {
        this.setState({
          isShowAddNodeConfig: true,
        });
      },
      DELETE_POINTER: ({ data }) => {
        const { origin, source, target } = data;
        const { previousNodeId, nextNodeId } = origin;
        const previousNodeHasPointerCount =
          this.state.nodes.nodePointerResponseList.filter(
            (s) => s.previousNodeId === previousNodeId,
          ).length;
        const pointToNextNodePointerCount =
          this.state.nodes.nodePointerResponseList.filter(
            (s) => s.nextNodeId === nextNodeId,
          ).length;
        if (
          previousNodeHasPointerCount === 1 ||
          pointToNextNodePointerCount === 1
        ) {
          notifyError('当前指针为上一节点或后一节点的单指针，不允许删除!');
          return;
        }
        let nodePointerResponseListUnuse =
          this.state.nodes.nodePointerResponseList.filter((s) =>
            s.previousNodeId !== origin.previousNodeId
              ? true
              : s.nextNodeId !== origin.nextNodeId,
          );
        this.setState(
          {
            nodes: {
              nodePointerResponseList: nodePointerResponseListUnuse,
              nodeResponseList: this.state.nodes.nodeResponseList,
            },
          },
          () => {
            notifySuccess(`已删除节点指针 [${source}] - [${target}]`);
            this.refresh();
          },
        );
      },
    };
    clickItemFuncMap[clickItem](selectedElement);
  };

  // 删除节点
  deleteNode = (a) => {
    this.handleCancelDeleteNodeConfig();
    const node = a;
    this.recursiveCollectAliveNodeAndPointers(
      this.state.startNode.nodeId,
      this.state.nodeInfo.value[0].nodeId,
      this.state.aliveNodes,
      this.state.alivePointers,
      node,
    );
  };

  // 删除节点时循环调用
  recursiveCollectAliveNodeAndPointers = (
    currentNodeId,
    removeNodeId,
    aliveNodes,
    alivePointers,
    node,
  ) => {
    const currentNodePointers = this.state.nodes.nodePointerResponseList.filter(
      (e) => {
        return (
          e.previousNodeId === currentNodeId && e.nextNodeId !== removeNodeId
        );
      },
    );
    const currentNodeChildren = currentNodePointers.map((e) => e.nextNodeId);
    let aliveNodesUnuse = aliveNodes.concat(currentNodeChildren);
    let alivePointersUnuse = alivePointers.concat(currentNodePointers);
    this.setAlive(aliveNodesUnuse, alivePointersUnuse, node);
    currentNodeChildren.forEach((e, index) => {
      // react 解决循环调用函数bug
      if (index !== currentNodeChildren.length - 1) {
        setTimeout(() => {
          this.recursiveCollectAliveNodeAndPointers(
            e,
            removeNodeId,
            aliveNodesUnuse,
            alivePointersUnuse,
            node,
          );
        }, 100);
      }
    });
  };

  setAlive(aliveNodesUnuse, alivePointersUnuse, node) {
    this.setState(
      {
        aliveNodes: aliveNodesUnuse,
        alivePointers: alivePointersUnuse,
      },
      () => {
        // let { endNode, startNode, aliveNodes, alivePointers, nodes } = this.state;
        let nodesUnuse = this.state.nodes;
        let alivePointersUnuse2 = this.state.alivePointers;
        let aliveNodesUnuse2 = this.state.aliveNodes.filter(
          (e) => e !== this.state.endNode.nodeId,
        );
        const previousNodeIds = alivePointersUnuse2
          .map((e) => e.previousNodeId)
          .filter((e, index, arr) => arr.indexOf(e) === index);
        const noRootNodes = aliveNodesUnuse2.filter(
          (e) => previousNodeIds.indexOf(e) === -1,
        );
        noRootNodes.forEach((e) => {
          const pointer = {
            previousNodeId: e,
            nextNodeId: this.state.endNode.nodeId,
          };
          nodesUnuse.nodePointerResponseList.push(pointer);
          alivePointersUnuse2.push(pointer);
        });
        nodesUnuse.nodeResponseList = this.state.nodes.nodeResponseList.filter(
          (e) => this.state.aliveNodes.includes(e.nodeId),
        );
        nodesUnuse.nodePointerResponseList =
          this.state.nodes.nodePointerResponseList.filter((e) =>
            this.state.alivePointers.includes(e),
          );
        if (
          nodesUnuse.nodeResponseList.length === 0 &&
          nodesUnuse.nodePointerResponseList.length === 0
        ) {
          nodesUnuse.nodePointerResponseList.push({
            previousNodeId: this.state.startNode.nodeId,
            nextNodeId: this.state.endNode.nodeId,
          });
        }
        this.setState(
          {
            aliveNodes: aliveNodesUnuse2,
            nodes: nodesUnuse,
            alivePointers: alivePointersUnuse2,
          },
          () => {
            notifySuccess(`已删除节点 [${node.name}]`);
            this.refresh();
            this.setState({
              aliveNodes: [],
              alivePointers: [],
            });
          },
        );
      },
    );
  }

  // 新增子流程，插入子流程
  addNodeEvent = (type, node) => {
    let { nodes, currentSelectedElement, endNode } = this.state;
    let nodeResponseListUnuse = nodes.nodeResponseList;
    let nodesUnuse = nodes;
    const nodeId =
      nodeResponseListUnuse.length === 0
        ? 1
        : nodeResponseListUnuse[nodeResponseListUnuse.length - 1].nodeId + 1;
    nodesUnuse.nodeResponseList.push({
      nodeId: nodeId,
      isNew: true,
      nodeBlockId: node.nodeBlock,
      nodeBlockType: node.nodeBlockType,
      nodeName: node.nodeBlockName,
    });
    if (currentSelectedElement.dataType === 'node') {
      nodesUnuse.nodePointerResponseList = nodes.nodePointerResponseList.concat(
        [
          {
            previousNodeId: currentSelectedElement.value[0].nodeId,
            nextNodeId: nodeId,
          },
          {
            previousNodeId: nodeId,
            nextNodeId: endNode.nodeId,
          },
        ],
      );
      notifySuccess(
        `新增节点 [${currentSelectedElement.name}] 子节点 [${node.nodeBlockName}${nodeId}]`,
      );
    }
    if (currentSelectedElement.dataType === 'edge') {
      const previousNodeId = currentSelectedElement.data.origin.previousNodeId;
      const nextNodeId = currentSelectedElement.data.origin.nextNodeId;
      nodesUnuse.nodePointerResponseList = nodes.nodePointerResponseList.concat(
        [
          {
            previousNodeId,
            nextNodeId: nodeId,
          },
          {
            previousNodeId: nodeId,
            nextNodeId,
          },
        ],
      );
      nodesUnuse.nodePointerResponseList = nodes.nodePointerResponseList.filter(
        (s) =>
          s.previousNodeId === previousNodeId
            ? s.nextNodeId !== nextNodeId
            : true,
      );
      notifySuccess(
        `插入节点 [${currentSelectedElement.data.source}] 子节点 [${node.nodeBlockName}${nodeId}]`,
      );
    }
    this.setState({
      nodes: nodesUnuse,
    });
    this.refresh();
  };

  // 关闭右键点击后列表
  closeMenu = () => {
    this.setState({
      visible: false,
    });
  };

  // 关闭新增子流程弹窗
  handleCancel = () => {
    this.setState({
      isShowAddNodeConfig: false,
    });
  };

  // 关闭删除节点弹窗
  handleCancelDeleteNodeConfig = () => {
    this.setState({
      isShowDeleteNodeConfig: false,
    });
  };

  // 保存决策图
  saveDiagram = () => {
    const data = {
      nodes: this.state.nodes.nodeResponseList,
      nodePointers: this.state.nodes.nodePointerResponseList.map(
        ({ previousNodeId, nextNodeId }) => ({ previousNodeId, nextNodeId }),
      ),
    };
    this.props.dispatch({
      type: 'dgmp/saveDiagram',
      payload: {
        diagramId: history.location.query.id,
        values: data,
      },
      callback: (res) => {
        if (res) {
          message.error('保存失败');
        } else {
          message.success('决策图保存成功');
          this.queryDiagram();
          // this.refresh();
          this.loadData();
        }
      },
    });
  };

  // 保存后获取决策图
  queryDiagram = () => {
    this.props.dispatch({
      type: 'dgmp/getDecisionGraphMap',
      payload: {
        values: history.location.query.id,
      },
      callback: (res) => {
        let startNodeUnuse = {
          nodeId: res.startNode.nodeId,
          nodeName: res.startNode.nodeName,
          nodeBlockId: res.startNode.nodeBlockId,
          nodeBlockType: res.startNode.nodeBlockType,
        };
        let endNodeUnuse = {
          nodeId: res.endNode.nodeId,
          nodeName: res.endNode.nodeName,
          nodeBlockId: res.endNode.nodeBlockId,
          nodeBlockType: res.endNode.nodeBlockType,
        };
        let nodeResponseListUnuse = res.nodeResponseList.sort(
          (p, n) => p.nodeId - n.nodeId,
        );
        nodeResponseListUnuse.forEach((e) => (e.isNew = false));
        let nodePointerResponseListUnuse = res.nodePointerResponseList.sort(
          (p, n) => p.id - n.id,
        );
        this.setState({
          startNode: startNodeUnuse,
          endNode: endNodeUnuse,
          nodes: {
            nodeResponseList: nodeResponseListUnuse,
            nodePointerResponseList: nodePointerResponseListUnuse,
          },
        });
      },
    });
  };

  testRun = () => {
    if (
      JSON.stringify(this.state.nodes) ===
      JSON.stringify(this.state.originNodes)
    ) {
      this.props.dispatch({
        type: 'dgmp/checkDiagram',
        payload: {
          values: history.location.query.id,
        },
        callback: (res) => {
          if (res && res.length > 0) {
            message.error('检测不通过，该决策图配置存在问题');
            this.setState({
              showCheckDialog: true,
              diagramCheckData: res,
            });
          } else {
            message.success('检测通过，该决策图配置无问题');
          }
        },
      });
    } else {
      notifyError('当前流程为未保存状态，请先保存后再操作！');
    }
  };

  // 插入子流程table弹窗数据
  fetchData = () => {
    this.props.dispatch({
      type: 'dgmp/queryNodeBlock',
      payload: {
        values: history.location.query.id,
      },
      callback: (res) => {
        if (res) {
          this.setState({
            tableData: res,
          });
        }
      },
    });
  };

  render() {
    let {
      visible,
      left,
      top,
      currentSelectedElement,
      currentClickType,
      isShowAddNodeConfig,
      isShowDeleteNodeConfig,
      nodeInfo,
      tableData,
    } = this.state;
    return (
      <div className={styles.graph}>
        <div className={styles.title}>
          {history.location.query.title}{' '}
          {'(' + history.location.query.version + ')'}
        </div>
        <div className={styles.graphChart} id="chart1">
          <div id="test-dome"></div>
        </div>
        {visible && (
          <ul
            className={styles.linkMenu}
            style={{ left: left + 'px', top: top + 'px' }}
          >
            {currentClickType === 'POINTER' && (
              <li
                onClick={() => {
                  this.handleContextMenu(
                    currentSelectedElement,
                    'CONDITION_CONFIG',
                  );
                }}
              >
                条件配置
              </li>
            )}
            {currentClickType === 'POINTER' && (
              <li
                onClick={() => {
                  this.handleContextMenu(
                    currentSelectedElement,
                    'INSERT_CHILD_NODE',
                  );
                }}
              >
                插入子流程
              </li>
            )}
            {currentClickType === 'POINTER' && (
              <li
                onClick={() => {
                  this.handleContextMenu(
                    currentSelectedElement,
                    'DELETE_POINTER',
                  );
                }}
              >
                删除连线
              </li>
            )}
            {currentClickType === 'NODE' && (
              <li
                onClick={() => {
                  this.handleContextMenu(
                    currentSelectedElement,
                    'ADD_CHILD_NODE',
                  );
                }}
              >
                新增子流程
              </li>
            )}
            {currentClickType === 'NODE' &&
              currentSelectedElement.value[0] &&
              currentSelectedElement.value[0].nodeBlockType === 'RULE' && (
                <li
                  onClick={() => {
                    this.handleContextMenu(
                      currentSelectedElement,
                      'INPUT_ITEM_CONFIG',
                    );
                  }}
                >
                  入参配置
                </li>
              )}
            {currentClickType === 'NODE' && (
              <li
                onClick={() => {
                  this.handleContextMenu(currentSelectedElement, 'DELETE_NODE');
                }}
              >
                删除节点
              </li>
            )}
            {currentClickType === 'NODE' &&
              currentSelectedElement.value[0] &&
              currentSelectedElement.value[0].nodeBlockType && (
                <li
                  onClick={() => {
                    this.handleContextMenu(
                      currentSelectedElement,
                      'NODE_CONFIG',
                    );
                  }}
                >
                  节点配置
                </li>
              )}
          </ul>
        )}
        <div className={styles.btn_contain}>
          <ButtonML
            size="large"
            value="保存"
            disabled={!history.location.query.saveable}
            onClick={this.saveDiagram}
          />
          <ButtonML size="large" value="刷新" onClick={this.loadData} />
          <ButtonML size="large" value="试运行" onClick={this.testRun} />
        </div>
        {/* 添加子流程 */}
        <ModalML
          title="新增"
          visible={isShowAddNodeConfig}
          handleCancel={this.handleCancel}
          width="900px"
        >
          <TablePage
            handleCancel={this.handleCancel}
            addNodeEvent={this.addNodeEvent}
            tableDataProps={tableData}
          />
        </ModalML>
        <ModalML
          title="提示"
          visible={isShowDeleteNodeConfig}
          handleCancel={this.handleCancelDeleteNodeConfig}
          width="400px"
        >
          <p>是否确认删除节点块[{nodeInfo.name}]?</p>
          <div className={styles.btn_contain}>
            <ButtonML
              size="large"
              value="取消"
              onClick={this.handleCancelDeleteNodeConfig}
            />
            <ButtonML
              size="large"
              value="确定"
              onClick={() => {
                this.deleteNode(nodeInfo);
              }}
            />
          </div>
        </ModalML>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ...state.dgmp,
  };
}

export default connect(mapStateToProps)(GraphMap);
